module.exports = __webpack_public_path__ + "img/junior-advanced.b1cd106a.jpg";